import FormBase from "../FormBase";
import Professional from '../../models/Professional'
import FormFieldBase from "../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";
import ProfissionalService from "../../services/ProfessionalService";
import { RegiaoOptions } from "../../data/Regiao";
import { EstabelecimentoOptions } from "../../data/Estabelecimentos";


export default class PersonalDataForm implements FormBase {

    Region: FormFieldBase;
    Establishment: FormFieldBase;
    Name: FormFieldBase;
    CRM: FormFieldBase;
    Expertise: FormFieldBase;
    BirthDate: FormFieldBase;
    RG: FormFieldBase;
    OM: FormFieldBase;
    CPF: FormFieldBase;
    CellPhone: FormFieldBase;
    BusinessPhone: FormFieldBase;
    Email: FormFieldBase;

    constructor(Establishment: string, CPF: string, Name: string, RG: string, OM: string, CRM: string, BusinessPhone: string,
        CellPhone: string, Email: string, region: string, BirthDate?: Date, Expertise?: string) {

        this.Establishment = new FormFieldBase(Establishment, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.CPF = new FormFieldBase(CPF, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.CPF)]);
        this.Name = new FormFieldBase(Name, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.RG = new FormFieldBase(RG, [new ValidationBase("", ValidationType.RG)]);
        this.OM = new FormFieldBase(OM, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.CRM = new FormFieldBase(CRM, [new ValidationBase("", ValidationType.CRM)]);
        this.Expertise = new FormFieldBase(Expertise, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.BirthDate = new FormFieldBase(BirthDate, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.DATANASCIMENTO), new ValidationBase("A data de nascimento informada é inválida.", ValidationType.DATA)]);
        this.BusinessPhone = new FormFieldBase(BusinessPhone, [new ValidationBase("O Telefone Comercial informado é inválido.", ValidationType.TELEFONE)]);
        this.CellPhone = new FormFieldBase(CellPhone, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.CELULAR)]);
        this.Email = new FormFieldBase(Email, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.EMAIL)]);
        this.Region = new FormFieldBase(region, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
    }

    static NewInstance(): PersonalDataForm {
        return new PersonalDataForm("", "", "", "", "", "", "", "", "", "");
    }

    ValidateToGoNextStep(): string {

        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, preencha os dados obrigatórios."
        } else {
            return "";
        }
    }

    async CallInsertOrUpdateApi(Professional: Professional): Promise<any> {
        const dataJson = this.getJsonObjet();
        return ProfissionalService.postInsertOrUpdateProfissionalSpecialauthorization(dataJson, Professional.Id);
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Name":
                return this.Name
            case "CRM":
                return this.CRM
            case "BirthDate":
                return this.BirthDate
            case "RG":
                return this.RG
            case "OM":
                return this.OM
            case "Expertise":
                return this.Expertise
            case "CPF":
                return this.CPF
            case "BusinessPhone":
                return this.BusinessPhone
            case "CellPhone":
                return this.CellPhone
            case "Email":
                return this.Email
            case "Region":
                return this.Region
            case "Establishment":
                return this.Establishment

            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet() {

        return {
            "Id": 0,
            "Name": this.Name.Value,
            "BirthDate": this.BirthDate.Value,
            "RG": this.RG.Value,
            "CPF": this.CPF.Value,
            "CellPhone": this.CellPhone.Value,
            "Email": this.Email.Value,
            "CRM": this.CRM.Value,
            "BusinessPhone": this.BusinessPhone.Value,
            "ExpertiseId": this.Expertise.Value.Id,
            "IssuingAgency": this.OM.Value.value,
            "EstablishmentId": EstabelecimentoOptions.find(r => r.value === this.Establishment.Value)?.id,
            "RequestType": {
                "Id": 3,
                "Name": 'Autorização Especial'
            },
            "RequestRegion": RegiaoOptions.find(r => r.value === this.Region.Value)?.id,
        }
    }
}